/* global axios */
import ApiClient from './ApiClient';

class LaisDataRegistryAPI extends ApiClient {
  constructor() {
    super('lais_data_registry', { accountScoped: true });
  }

  sources(params = {}) {
    return axios.get(`${this.url}/sources`, { params });
  }

  runs(params = {}) {
    return axios.get(`${this.url}/runs`, { params });
  }

  updateSource(id, payload = {}) {
    return axios.patch(`${this.url}/sources/${id}`, payload);
  }

  runSource(id) {
    return axios.post(`${this.url}/sources/${id}/run`, {});
  }

  cancelRun(id) {
    return axios.post(`${this.url}/runs/${id}/cancel`, {});
  }

  people(params = {}) {
    return axios.get(`${this.url}/people`, { params });
  }

  person(id) {
    return axios.get(`${this.url}/people/${id}`);
  }

  records(params = {}) {
    return axios.get(`${this.url}/records`, { params });
  }

  record(id) {
    return axios.get(`${this.url}/records/${id}`);
  }

  integrity(params = {}) {
    return axios.get(`${this.url}/integrity`, { params });
  }

  importCatalog(payload = {}) {
    return axios.post(`${this.url}/sources/import_catalog`, payload);
  }

  upsertRecord(payload = {}) {
    return axios.post(`${this.url}/records`, payload);
  }

  bulkUpsertRecords(payload = {}) {
    return axios.post(`${this.url}/records/bulk`, payload);
  }

  repairIntegrity(payload = {}) {
    return axios.post(`${this.url}/integrity/repair`, payload);
  }
}

export default new LaisDataRegistryAPI();
